import type { TagVariants } from '../../types'
import * as Comp from './tag.label.styles'

type TTagLabelProps = {
  children: string
  testID?: string
  variant?: TagVariants
}

export function TagLabel({ children, testID, variant }: TTagLabelProps) {
  const componentProperties = {
    testID,
    variant,
  }

  return (
    <Comp.Label numberOfLines={1} {...componentProperties}>
      {variant === 'ganhe-stix'
        ? 'Ganhe mais stix'
        : variant === 'trocar-stix'
          ? 'Trocar com stix'
          : children}
    </Comp.Label>
  )
}
